"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function Hero() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.2
  });
  const heroRef = useRef<HTMLDivElement>(null);
  const [parallaxOffset, setParallaxOffset] = useState(0);
  useEffect(() => {
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReducedMotion) {
      return;
    }
    const handleScroll = () => {
      if (heroRef.current) {
        const scrolled = window.scrollY;
        const heroHeight = heroRef.current.offsetHeight;
        if (scrolled < heroHeight) {
          setParallaxOffset(scrolled * 0.02);
        }
      }
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return <div ref={heroRef} className="relative w-full h-screen overflow-hidden bg-dark-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1488905/img/hero_alphavision_display_technology.png)",
      transform: `translateY(${parallaxOffset}%)`,
      transition: "transform 0.1s ease-out"
    }} />
      {}
      <div className="absolute inset-0 bg-dark-background/60" />
      {}
      <div className="relative z-10 flex items-center justify-center h-full px-4">
        <div ref={contentRef} className="max-w-4xl mx-auto text-center" style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(20px)",
        transition: "opacity 200ms ease-out, transform 200ms ease-out"
      }}>
          {}
          <p className="text-sm font-normal mb-4 !text-[hsl(0,0%,100%)]">
            Professional Audio-Visual Solution Provider
          </p>

          {}
          <h1 className="text-5xl font-bold leading-tight !text-[hsl(0,0%,100%)] md:text-6xl">Transforming Display and Information Technology for a Better Life</h1>
        </div>
      </div>
    </div>;
}